export const FETCH_FILE = 'files/FETCH_FILE';
export const FETCH_FILES_CAUSE = 'files/FETCH_FILES_CAUSE';
export const UPLOAD_FILE_INFO = 'file/UPLOAD_FILE';
export const UPDATE_FILE_INFO = 'file/UPDATE_FILE';